import { combineReducers, createStore } from 'redux';
import { mainReducer } from './reducers/Main';

export const rootReducer = combineReducers({
  Main: mainReducer,
});

export const store = createStore(rootReducer, {});